module.exports = __webpack_public_path__ + "static/media/lock.6e0dc76d.svg";